import React, { useEffect, useRef, useState } from 'react';
import { MdMiscellaneousServices } from "react-icons/md";
import "./SelectionLayout.css";

import { AiFillFormatPainter } from "react-icons/ai";
import { IoSettings } from "react-icons/io5";
import { MdAdminPanelSettings, MdOutlineDisplaySettings } from "react-icons/md";
import { TbRosetteDiscountCheckFilled } from "react-icons/tb";
import useApiFetcher from '../../../hooks/useApiFetcher';
import RiskIndicator from '../../RiskIndicator/RiskIndicator';
import GaugeMeter from '../../DealerShipDashBoard/GaugeMeter';
import GaugeMeter2 from '../../DealerShipDashBoard/GaugeMeter2';



// const labels = ['Service Contract', 'Maintenance Upgrade', 'Platinum Service', 'Gap Insurance'];
const SelectionLayout = ({ setBackButtonClicked, statusArr,isSpeaking, isListening, isThinking, apiData, coreFeature, partialFeature, index, priceArr, setIndex, labels = [], status = [], setStatus, speakSelectedText, unSelectionScript, reSelectionScript, scriptArr, isSpeakingEnabled, totalPrice, tempArr, monthlyPayment, userQueriesHistory }) => {
  const { apiFetcher } = useApiFetcher()
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const handleChange = async (index) => {
    const newStatus = !status[index];
  if (status[index] === newStatus) return;
    // Update the status array
    const updatedStatus = status.map((status, i) => (i === index ? !status : status));

    // If deselecting the first item, deselect all
    // if (index === 0 && !updatedStatus[index]) {
    //   setStatus(Array(status.length).fill(false));
    //   scriptArr.length = 0;
    //   const newScript = unSelectionScript[index];
    //   const str = newScript.split(".");
    //   str.forEach((sentence) => scriptArr.push(sentence));

    //   // Update the total price to 0 and include it in the speech
    //   const unSelectionScriptandTotal = `${unSelectionScript[index]} Your monthly payment would be 0 dollars`;
    //   await speakSelectedText(unSelectionScriptandTotal);
    //   return;
    // }

    // Update the status and calculate new price
    // statusArr = [...updatedStatus];
    setStatus(updatedStatus);

    // Calculate new tempArr and total price
    const newTempArr = updatedStatus.map((status, i) => (status ? priceArr[i] : 0));
    console.log(newTempArr, 'newtempar')
    const newTotalPrice = newTempArr.reduce((sum, price) => sum + price, 0);
    function calculatePMT(rate, nper, pv) {
      if (pv === 0) return 0; // If loan amount is zero, no payment needed
      if (nper <= 0) return 0; // Avoid division errors
      if (rate === 0) return pv / nper; // Simple division when rate is zero
      rate = rate / 100;
      const monthlyRate = rate / 12;
      const pmt = (monthlyRate * pv) / (1 - Math.pow(1 + monthlyRate, -nper));
      return pmt;
    }
    const annualInterestRate = Number(`${apiData?.deal.intrestedRate}`);
    const totalPeriods = Number(`${apiData?.deal.financeDuration}`);
    const allSelected = updatedStatus.every(status => status === true);
    // const summaryStep = apiData?.getScript?.steps.find(
    //   (step) => step.stepTitle === "Summary" || step.stepTitle === "Bundle"
    // );

    //use a valid identifier like type instead of stepTitle as each client can enter diferenet titles for summary like bundle or summary 
    const summaryStep = apiData?.getScript?.steps.find(
      (step) => step.type === "Summary Script"
    );
    const discountPercentage = Number(summaryStep?.discountPercent);
    const discountTotalPayment = allSelected
      ? newTotalPrice * (1 - discountPercentage / 100)
      : newTotalPrice;
    const loanAmount = discountTotalPayment + Number(`${apiData?.deal.financeAmount}`)
    const monthlyPayment = calculatePMT(annualInterestRate, totalPeriods, loanAmount);

    // Update the state with new prices
    // setTotalPrice(newTotalPrice);

    // Determine the speech text
    isSpeakingEnabled = false;
    if (status[index] !== updatedStatus[index]) {
      if (updatedStatus[index]) {
        // Item reselected
        const reSelectionScriptandTotal = `${reSelectionScript[index]} Your monthly payment would be ${monthlyPayment.toFixed(2)} ${monthlyPayment < 1 ? "dollar" : "dollars"}`;
        console.log("Reselection speech:", reSelectionScriptandTotal);
        await speakSelectedText(reSelectionScriptandTotal);
      } else {
        // Item deselected
        const unSelectionScriptandTotal = `${unSelectionScript[index]} Your monthly payment would be ${monthlyPayment.toFixed(2)} ${monthlyPayment < 1 ? "dollar" : "dollars"}`;
        console.log("Unselection speech:", unSelectionScriptandTotal);
        await speakSelectedText(unSelectionScriptandTotal);
      }
    }
  };


  const icons = [
    <IoSettings />,
    <MdAdminPanelSettings />,
    <TbRosetteDiscountCheckFilled />,
    <MdOutlineDisplaySettings />,
    <AiFillFormatPainter />,
  ];
  // const prevHistoryLength = useRef(userQueriesHistory.length);

  // useEffect(() => {
  //   prevHistoryLength.current = userQueriesHistory.length; // Keep ref updated
  // }, [userQueriesHistory]);

  const handleNext = async () => {
    if (!isButtonClicked) {
      setIsButtonClicked(true); // Disable the button after clicking
      setBackButtonClicked(false)
      setIndex((prev) => prev + 1); // Increment the index
      StopTime()
    }
  };
  const StopTime = () => {
    setTimeout(() => {
      setIsButtonClicked(false);
      console.log("Start Button")
    }, 4000)
  }
  return (
    <div className="app-container">
      <div className="options-container animate-left-to-right">

        {labels && labels.map((label, index) => (
          <div key={index}>
            <div

              className={`option-polygon ${index + 1} ${status[index] ? 'selected' : ''}`}
            >
              <span className="textName">{label}</span>

              <div className="textContainer">
                <div className="iconImg">
                  {icons[index] || <MdMiscellaneousServices />}

                </div>

                {isSpeaking && !isListening && !isThinking &&
                  <input
                    type="checkbox"
                    checked={status[index]}
                    readOnly
                    onChange={() => handleChange(index)}
                    className="checkbox"
                  />}

              </div>

            </div>
            <div className="feature-label">
              {status[index] ? coreFeature[index] : partialFeature[index]}
            </div>
            <div className='priceCon'><b>${tempArr[index]} </b></div>
          </div>
        ))}
      </div>
      {/* <div className='priceCon'>

      {tempArr.map((price, index) => (
      <div key={index} className="price-item">
        <h6>${price}</h6>
      </div>
    ))}
    </div> */}

      <div className="price-container">
        <p className="total-price"><b>Bundle Total:</b> ${totalPrice} {apiData.deal.financeDuration} <b>Months  @</b>{apiData.deal.intrestedRate}%APR <b>Total Monthly Payment:</b> ${monthlyPayment.toFixed(2)}</p>
      </div>

      {
        isSpeaking && !isListening && !isThinking ? (
          <button className='buttonLoan' onClick={() => handleNext(userQueriesHistory)}>{`Proceed to ${status.every((status) => status)
            ? "Checkout"
            : "Partial Bundle"
            } `}</button>
        ) :
          (<button className='buttonLoandisable' >
            Proceed to Partial Bundle
          </button>
          )
      }

      {/* Risk indicator */}
      {/* <RiskIndicator status={status} /> */}
      <div className='meterContainer'>
      <GaugeMeter status={status}/>
      <GaugeMeter2 status={status}/>
      </div>

    </div>
  );
};

export default SelectionLayout;
